import {DATA} from '@wix/component-protocol/schema' // eslint-disable-line wix-editor/no-internal-import
import type {Builder} from '@wix/document-services-types'

export interface IBaseData {
    getDataType(): Builder.DataType
    toBuilderDataItem(): Builder.DataItem
}

export type PrimitiveDataTypes = 'text' | 'number' | 'boolean' | 'url' | 'image' | 'dateTime'
export type DataTypes = PrimitiveDataTypes | 'array' | 'object'

export type PrimitiveDefaultValue = string | number | boolean
export type ArrayDefaultValue = PrimitiveDefaultValue[]
export type DefaultValue = PrimitiveDefaultValue | ArrayDefaultValue

export abstract class BaseDataBuilder implements IBaseData {
    readonly dataType: DataTypes
    readonly displayName: string
    readonly defaultValue: DefaultValue

    constructor(dataType: DataTypes, displayName: string, defaultValue: DefaultValue) {
        this.dataType = dataType
        this.displayName = displayName
        this.defaultValue = defaultValue
        if (!this.displayName) {
            throw new Error('DisplayName is required')
        }
    }

    getDataType(dataType: DataTypes = this.dataType): Builder.DataType {
        const builderDataTypeMap: Record<string, Builder.DataType> = {
            text: DATA.DATA_TYPE.text,
            number: DATA.DATA_TYPE.number,
            boolean: DATA.DATA_TYPE.booleanValue,
            url: DATA.DATA_TYPE.link,
            image: DATA.DATA_TYPE.image,
            dateTime: DATA.DATA_TYPE.localDateTime
        }
        return builderDataTypeMap[dataType]
    }

    toBuilderDataItem(): Builder.DataItem {
        return {
            dataType: this.getDataType(),
            defaultValue: this.defaultValue,
            displayName: this.displayName
        }
    }
}
